import React from 'react'
import { SfSelectProps } from '@storefront-ui/react'
import { UseFormRegister } from 'react-hook-form'
import SfSelect from '../overrides/SfSelect'

function NxSelectInput({
  label,
  error,
  register,
  name,
  id,
  onChange,
  ...props
}: {
  name?: string;
  id?: string;
  label: string | React.ReactNode;
  error?: string;
  register?: UseFormRegister<any>;
  onChange?: ( e: React.ChangeEvent<HTMLInputElement> ) => void;
} & SfSelectProps ) {
  return (
    <label htmlFor={name} className="w-full space-y-2">
      <span className="font-light">
        {label}
        {props.required && <span className="text-error ml-1">{`*`}</span>}
      </span>
      <SfSelect
        name={name}
        id={id}
        {...( register && register( name || id || `` ),
        {
          ...( onChange && {
            onChange
          })
        })}
        {...( !register &&
          onChange && {
          onChange
        })}
        {...props}
      />
      {error && <p className="mt-2 text-error text-center mx-auto">{error}</p>}
    </label>
  )
}

export default NxSelectInput
